$(document).ready(function() {


function slider(dots, slider, item){
    for (let i = 1; i <= $(`${item}`).length; i++) {
        $(`${dots}`).append(
          '<div class="slider_navigators"><div class="dot"></div></div>'
        );
      }

    $(`${slider}`).slick({
        dots: false,
        arrows: true,
        infinite: true,
        asNavFor: `${dots}`,
      });
    
      $(`${dots}`).slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: `${slider}`,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: "30px",
      });
}
slider('.shb--stickers-dots.dots-buzzpatch', ".shb--stickers.sticker-buzzpatch", ".shb--stickers.sticker-buzzpatch .shb--stickers-item")
slider('.shb--stickers-dots.dots-adultbuzzpatch', ".shb--stickers.sticker-adultbuzzpatch", ".shb--stickers.sticker-adultbuzzpatch .shb--stickers-item")
slider('.shb--stickers-dots.dots-tickpatch', ".shb--stickers.sticker-tickpatch", ".shb--stickers.sticker-tickpatch .shb--stickers-item")
slider('.shb--stickers-dots.dots-magicpatch', ".shb--stickers.sticker-magicpatch", ".shb--stickers.sticker-magicpatch .shb--stickers-item")
slider('.shb--stickers-dots.dots-natpatdecal', ".shb--stickers.sticker-natpatdecal", ".shb--stickers.sticker-natpatdecal .shb--stickers-item")
slider('.shb--stickers-dots.dots-natpattoesocks', ".shb--stickers.sticker-natpattoesocks", ".shb--stickers.sticker-natpattoesocks .shb--stickers-item")



})